<template>
  <div>
    <el-button size='small' type='success' @click='confirm()'>Confirm</el-button>
    <router-link :to="{ name: 'Answer'}">Answer</router-link>
  </div>
</template>

<script>
import { assessmentConfirm } from '@/services/answerer/assessment.service'
export default {
  methods: {
    async confirm () {
      const result = await assessmentConfirm(this.$store.state.assessment).catch(err => {
        this.$message({
          message: `Server: ${err}`,
          type: 'error',
          duration: 5000
        });
        console.log(result);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/AssessmentConfirm.vue